/* Cart is the only persisted edit source. Existing _set_id, _person and
   _customisation_id identify groups, people and paid service pairs. */
(function () {
  'use strict';
  if (window.PTCartEdit) return;
  var editId = new URLSearchParams(window.location.search).get('edit_set');
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function fail(message) { throw new Error(message); }
  function identity(line) {
    var props = line.properties || {};
    return JSON.stringify([String(line.variant_id || line.id), Object.keys(props).sort().map(function (key) { return [key, props[key]]; })]);
  }
  function signature(lines) {
    return JSON.stringify(lines.map(function (line) { return [identity(line), line.quantity]; }).sort());
  }
  function request(path, payload) {
    return fetch(root + path, payload ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    } : { cache: 'no-store' }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) fail(json.description || 'The cart could not be updated.');
        return json;
      });
    });
  }
  function garments(cart) {
    return cart.items.filter(function (line) { return (line.properties || {})._set_id === editId; });
  }
  function groupLines(cart) {
    var lines = garments(cart);
    var links = lines.map(function (line) { return line.properties._customisation_id; }).filter(Boolean);
    return cart.items.filter(function (line) {
      return lines.indexOf(line) !== -1 || links.indexOf((line.properties || {})._customisation_id) !== -1;
    });
  }
  function allowedProperties(line, names) {
    Object.keys(line.properties || {}).forEach(function (name) {
      if (names.indexOf(name) === -1) fail('This configuration contains additional saved details (' + name + ') that cannot be safely edited here. Your cart is unchanged.');
    });
  }
  // Only the three historical, code-defined order values have an exact
  // reverse mapping. Other missing/retired codes require customer selection.
  function restoreStyle(gender, properties) {
    var code = properties._style_code;
    if (!code) {
      var prefixes = { WOMEN: 'WOMAN', MEN: 'MAN', GIRLS: 'GIRL', BOYS: 'BOY' };
      var legacy = { 'Full Sleeve': 'FULL_PAJAMA', 'Short Sleeve': 'SHORT_PAJAMA', 'Shorts Set': 'SHORT_SHORTS' };
      if (legacy[properties.Style]) code = prefixes[gender] + '_' + legacy[properties.Style];
    }
    return code && window.PTStyleCatalog.find(gender, code) ? code : null;
  }
  function showNotice(anchor, message) {
    if (!anchor) return;
    var notice = anchor.parentNode.querySelector('[data-pt-edit-notice]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-pt-edit-notice', '');
      notice.setAttribute('role', 'status');
      notice.className = 'small-text';
      anchor.before(notice);
    }
    notice.textContent = message || '';
    notice.hidden = !message;
  }
  function showRecovery(container, rebuild) {
    if (!container) return;
    var actions = document.createElement('p');
    if (rebuild) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn btn--secondary';
      button.textContent = 'Reconfigure this set';
      button.addEventListener('click', rebuild);
      actions.appendChild(button);
      actions.appendChild(document.createTextNode(' · '));
    }
    var cartLink = document.createElement('a');
    cartLink.href = root + 'cart';
    cartLink.textContent = 'Return to cart';
    actions.appendChild(cartLink);
    actions.appendChild(document.createTextNode(' · '));
    var retry = document.createElement('a');
    retry.href = window.location.href;
    retry.textContent = 'Try again';
    actions.appendChild(retry);
    container.appendChild(actions);
    container.hidden = false;
  }
  function load(data, kind, sizesForGender) {
    return request('cart.js').then(function (cart) {
      var lines = garments(cart);
      if (!lines.length) fail('This configuration is no longer in your cart. Return to your cart to continue.');
      var seen = {};
      var people = lines.map(function (line) {
        var p = line.properties;
        if (String(line.product_id) !== String(data.productId) || line.quantity !== 1 || line.selling_plan_allocation || !p._person || seen[p._person]) {
          fail('This cart group cannot be safely reconstructed. Your cart is unchanged.');
        }
        seen[p._person] = true;
        var garmentFields = ['Person', '_set_id', '_person', 'Style', '_style_code', 'Size', 'Customisation', '_customisation_id'];
        if (kind === 'matching') garmentFields = garmentFields.concat(['Person', '_relationship']);
        allowedProperties(line, garmentFields);
        var genders = Object.keys(data.genderVariants || {}).filter(function (gender) {
          return String(data.genderVariants[gender].variantId) === String(line.variant_id);
        });
        if (genders.length !== 1) fail('A saved customer type is no longer available. Your cart is unchanged.');
        var gender = genders[0];
        var style = restoreStyle(gender, p);
        var review = [];
        if (!style) review.push('choose a style' + (p.Style ? ' (saved: ' + p.Style + ')' : ''));
        if (!data.genderVariants[gender].available) review.push('review the unavailable customer type');
        var person = { id: p._person, gender: gender, size: p.Size || null, style: style, label: p.Person, cartCustomisationId: p._customisation_id || null, customisation: null, confirmed: true, expanded: false };
        if (p._customisation_id || p.Customisation) {
          var pair = cart.items.filter(function (entry) { return (entry.properties || {})._customisation_id === p._customisation_id; });
          if (!p._customisation_id || pair.length !== 2) fail('A linked Custom Size service is missing or ambiguous. Your cart is unchanged.');
          var service = pair.filter(function (entry) { return entry !== line; })[0];
          var info = window.PTCustomisation && window.PTCustomisation.getProductInfo();
          if (service.properties._set_id || service.quantity !== 1 || service.selling_plan_allocation || !info || !info.available || String(service.variant_id) !== String(info.variantId)) {
            fail('The linked Custom Size service cannot be safely restored. Your cart is unchanged.');
          }
          var c = service.properties;
          var genderLabels = kind === 'matching' ? { WOMEN: 'Woman', MEN: 'Man', GIRLS: 'Girl', BOYS: 'Boy' } : { WOMEN: 'Women', MEN: 'Men', GIRLS: 'Girls', BOYS: 'Boys' };
          if (c.Gender !== genderLabels[gender]) fail('The saved Custom Size customer type is inconsistent. Your cart is unchanged.');
          allowedProperties(service, ['Profile', 'Gender', 'Measurements Later', '_customisation_id', 'Top Size', 'Bottom Size', 'Style', '_style_code', 'Chest', 'Waist', 'Hips', 'Height', 'Notes']);
          var stylesMatch = p._style_code && c._style_code ? p._style_code === c._style_code : !!style && restoreStyle(gender, c) === style;
          if (!stylesMatch || ['Yes', 'No'].indexOf(c['Measurements Later']) === -1) fail('The saved Custom Size details are inconsistent. Your cart is unchanged.');
          if (['Top Size', 'Bottom Size'].some(function (field) { return c[field] && (sizesForGender(gender) || []).indexOf(c[field]) === -1; })) fail('A saved Custom Size option is no longer available. Your cart is unchanged.');
          person.customisation = { profileName: c.Profile || '', topSize: c['Top Size'] || null, bottomSize: c['Bottom Size'] || null, measurementsLater: c['Measurements Later'] === 'Yes', height: c.Height || '', notes: c.Notes || '' };
          ['Chest', 'Waist', 'Hips'].forEach(function (field) {
            if (c[field] && !/ in$/.test(c[field])) fail('A saved measurement has an unsupported format. Your cart is unchanged.');
            person.customisation[field.toLowerCase()] = (c[field] || '').replace(/ in$/, '');
          });
        } else if (!p.Size || (sizesForGender(gender) || []).indexOf(p.Size) === -1) {
          person.size = null;
          review.push('choose a size' + (p.Size ? ' (saved: ' + p.Size + ')' : ''));
        }
        if ((kind === 'matching') !== !!p._relationship) fail('This group belongs to a different builder. Your cart is unchanged.');
        if (review.length) {
          person.confirmed = false;
          person.expanded = true;
          person.editNotice = 'Please ' + review.join(' and ') + ', then confirm.';
        }
        return person;
      });
      var relationship = lines[0].properties._relationship;
      if (lines.some(function (line) { return line.properties._relationship !== relationship; })) fail('The saved relationship is ambiguous. Your cart is unchanged.');
      // _person has always ended in its creation counter; cart order may reverse.
      people.sort(function (a, b) { return Number(a.id.split('-').pop()) - Number(b.id.split('-').pop()); });
      if (people.some(function (person) { return !/\-\d+$/.test(person.id); })) fail('The saved person order is unknown. Your cart is unchanged.');
      return { people: people, relationship: relationship === 'custom' ? 'family' : relationship, lines: groupLines(cart) };
    });
  }
  /* Add only changed lines first. Never remove originals on a rejected add.
     Re-read keys after adds because discount changes can alter Shopify keys.
     A failed/uncertain request locks this edit until the cart is reviewed. */
  function save(session, items) {
    var desired = items;
    var originals = session.lines;
    var serviceIds = originals.concat(desired).map(function (line) { return line.properties._customisation_id; }).filter(Boolean);
    function affectedLines(cart) {
      return cart.items.filter(function (line) {
        var p = line.properties || {};
        return p._set_id === editId || serviceIds.indexOf(p._customisation_id) !== -1;
      });
    }
    var additions = desired.filter(function (line) { return !originals.some(function (old) { return identity(old) === identity(line); }); });
    var removals = originals.filter(function (line) { return !desired.some(function (next) { return identity(next) === identity(line); }); });
    var added = false;
    var attempted = false;
    return request('cart.js').then(function (cart) {
      if (signature(affectedLines(cart)) !== signature(originals)) fail('This configuration changed in another window. Reload before editing it.');
      if (!additions.length) return;
      attempted = true;
      return request('cart/add.js', { items: additions }).then(function () { added = true; });
    }).then(function () {
      return request('cart.js');
    }).then(function (cart) {
      var current = affectedLines(cart);
      if (signature(current) !== signature(originals.concat(additions))) fail('The cart changed during your update. Review your cart before continuing.');
      var updates = {};
      current.forEach(function (line) {
        if (removals.some(function (old) { return identity(old) === identity(line); })) updates[line.key] = 0;
      });
      return Object.keys(updates).length ? request('cart/update.js', { updates: updates }) : cart;
    }).then(function () { return request('cart.js'); }).then(function (cart) {
      var current = affectedLines(cart);
      if (signature(current) !== signature(desired)) fail('The update could not be verified. Please review your cart.');
      session.lines = current;
      return { ok: true, json: { items: current } };
    }).catch(function (error) {
      // Roll back additions only if all original lines still exist unchanged.
      // Never recreate removed original lines or guess after concurrent edits.
      return request('cart.js').then(function (cart) {
        var current = affectedLines(cart);
        if (signature(current) === signature(desired)) {
          session.lines = current;
          return { ok: true, json: { items: current } };
        }
        var originalPresent = originals.every(function (old) {
          return current.some(function (line) { return identity(line) === identity(old) && line.quantity === old.quantity; });
        });
        var updates = {};
        if (attempted && originalPresent) current.forEach(function (line) {
          if (additions.some(function (next) { return identity(line) === identity(next) && line.quantity === next.quantity; })) updates[line.key] = 0;
        });
        return (Object.keys(updates).length ? request('cart/update.js', { updates: updates }) : Promise.resolve()).then(function () {
          fail(error.message + (added ? ' Please review your cart before trying again.' : ' Reload this page before trying again.'));
        });
      });
    });
  }
  window.PTCartEdit = { id: editId, load: load, save: save, showNotice: showNotice, showRecovery: showRecovery };
})();
